import React from 'react'

import { GuideItem } from 'core/application/expenses/getEligibilityGuide'

import ExpenseIcon from './common/ExpenseIcon'

interface EligibilityGuideProps {
  title: string
  items: GuideItem[]
}

const EligibilityGuideItem: React.FC<GuideItem> = (item) => {
  return (
    <div className="expense_category_item">
      <ExpenseIcon expenseTypeId={item.id} />
      <p className=""> {item.name} </p>
    </div>
  )
}

const EligibilityGuide: React.FC<EligibilityGuideProps> = ({ title, items }) => {
  return (
    <div className="eligibility_guide">
      <h5>{title}</h5>
      <div className="mt-16">
        {items.map((item: GuideItem) => (
          <EligibilityGuideItem key={item.id} {...item} />
        ))}
      </div>
    </div>
  )
}

export default EligibilityGuide
